import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
} from "@/components/ui/card";

export const TrainingCardSkeleton = () => {
  return (
    <Card className="flex flex-col bg-card dark:bg-black">
      <CardHeader className="space-y-3 pb-4">
        <div className="flex items-center justify-between">
          <div className="h-10 w-10 rounded-full bg-muted animate-pulse"></div>
          <div className="flex items-center space-x-2">
            <div className="h-4 w-16 bg-muted animate-pulse"></div>
            <div className="h-6 w-20 bg-muted animate-pulse"></div>
          </div>
        </div>
        <div className="space-y-2">
          <div className="h-6 w-3/4 bg-muted animate-pulse"></div>
          <div className="h-4 w-1/2 bg-muted animate-pulse"></div>
        </div>
        <div className="flex items-center space-x-2">
          <div className="h-4 w-4 bg-muted animate-pulse"></div>
          <div className="h-4 w-24 bg-muted animate-pulse"></div>
        </div>
      </CardHeader>
      <CardContent className="grid gap-6 px-6">
        <div className="flex flex-wrap gap-2">
          {[1, 2, 3].map((i) => (
            <div key={i} className="h-6 w-20 bg-muted animate-pulse"></div>
          ))}
        </div>
        <div className="space-y-2">
          {[1, 2, 3].map((i) => (
            <div key={i} className="flex items-start">
              <div className="mr-2 h-2 w-2 bg-muted animate-pulse"></div>
              <div className="flex-1 h-4 bg-muted animate-pulse"></div>
            </div>
          ))}
        </div>
      </CardContent>
      <CardFooter className="mt-auto pt-6 px-6">
        <div className="h-10 w-full bg-muted animate-pulse"></div>
      </CardFooter>
    </Card>
  );
};
